import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import TreatmentSection from '@/pages/PatientCentresPage/components/treatmentSection'
import { getAllCentreTreatments, getAllPatientTreatments } from '@/store/treatments/actions'
import { setDataToCreateTurnTreatment } from '@/store/turns/actions'
import { getCentreSubCategory } from '@/utils/functions/getCentreSubCategory'

import s from './styles.module.scss'

const TreatmentTab = ({
  turnData,
  setOpenPopUp,
  setTreatmentSection,
  patientSelected,
  handleClose,
  directionOfAnimation,
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation('global')

  const [loading, setLoading] = useState(false)
  const centreDetail = useSelector((state) => state.centres.centreProfile)
  const selectedTurn = useSelector((state) => state.turns.selectedTurn)
  const isUpdate = !!selectedTurn
  const isPatientMissingInUpdate = isUpdate && selectedTurn?.patientCentre == null

  const treatmentTabFromUpdateTurn = async () => {
    setLoading(true)
    await dispatch(getAllCentreTreatments(selectedTurn.centre))
    await dispatch(getAllPatientTreatments(selectedTurn.centre, selectedTurn.patientCentre._id))
    setLoading(false)
  }

  const treatmentTabFromCreateTurn = async () => {
    setLoading(true)
    await dispatch(setDataToCreateTurnTreatment(turnData))
    await dispatch(getAllPatientTreatments(turnData.centreId, turnData.patientSelected._id))
    await dispatch(getAllCentreTreatments(turnData.centreId))
    setLoading(false)
  }

  useEffect(() => {
    if (!selectedTurn) {
      treatmentTabFromCreateTurn()
      return
    }

    if (!selectedTurn.patientCentre) return

    treatmentTabFromUpdateTurn()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTurn])

  return (
    <div className={directionOfAnimation}>
      {isPatientMissingInUpdate ? (
        <div className={s.noAvailableTreatments}>
          No hay sesiones disponibles ya que el{' '}
          {t(`subCategoryLabel.${getCentreSubCategory(centreDetail?.category)}.patient`)} fue eliminado.
        </div>
      ) : (
        <TreatmentSection
          setTreatmentSection={setTreatmentSection}
          setOpenPopUp={setOpenPopUp}
          patientSelected={patientSelected}
          setLoading={setLoading}
          loading={loading}
          handleClose={handleClose}
        />
      )}
    </div>
  )
}

export default TreatmentTab
